
export class CombinationTableController {
    private $element: JQuery;

    constructor(element: JQuery) {
        this.$element = element;
    }
}
